import React from 'react';
import { NumericMenu } from 'react-instantsearch-dom';

import { currencyCode } from 'Helpers/Geo/data';
import ranges from 'Helpers/Geo/price-ranges';

export default function PriceRangeFilter() {
  // Force all options to be selectable (prices are not filters)
  const transformItems = items => items.map(item => ({ ...item, noRefinement: false }));

  return (
    <React.Fragment>
      {ranges &&
        <NumericMenu
          attribute={`price.${currencyCode}`}
          items={ranges}
          transformItems={transformItems}
        />
      }
    </React.Fragment>
  );
}
